import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matchLocale',
  standalone: true
})
export class MatchLocalePipe implements PipeTransform {

  transform(list: any): string {
    // Get the locale from local storage
    const locale = JSON.parse((localStorage.getItem('user_lang') as string));

    if (!list) {
      return '';
    }

    if (!locale) {
      return list.title;
    }

    if (!list.titles) {
      return list.title; // Return original value if no locale or array
    }

    // Find the matching locale in the array
    const match = list.titles.find((item: any) => item.locale === locale);

    return match && match.title !== '0' ? match.title : list.title; // Return the matched title or original value
  }

}
